// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"333":"d25c4b85","591":"d25c4b85","668":"64671d07","719":"2e962135","721":"e7902b9e","752":"e7902b9e"}[chunkId] + ".chunk.css";
};